import { CustomButton } from "@/components/ui";
import { Flex, Typography } from "antd";
import { CSSProperties, FC, ReactNode } from "react";

type ComponentElements = 'wrapper' | 'title' | 'button'

type Props = {
  headerTitle: string
  buttonText?: string
  action: () => void
  styles?: Record<ComponentElements, CSSProperties>
  classnames?: Record<ComponentElements, string>
  prefixElement?: ReactNode  
}

export const DropdownHeaderWithAction: FC<Props> = ({
  headerTitle,
  buttonText,
  classnames,
  styles,
  action,
  prefixElement,
}) => {

  return (
    <Flex
      className={classnames?.wrapper}
      style={{
        padding: '16px 22px',
        ...styles?.wrapper
      }}
      justify={'space-between'}
      align={'center'}
    >
      <Typography.Text
        className={classnames?.title}
        style={{
          color: '#7B8082',
          ...styles?.title
        }}
      >
        {headerTitle}
      </Typography.Text>

     <Flex align="center" gap={8}>
        {prefixElement}
        {buttonText && (
          <CustomButton
            className={classnames?.button}
            style={{ ...styles?.button }}
            type={'link'}
            text={buttonText}
            onClick={action}
          />
        )}
      </Flex>
    </Flex>
  )
}